import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { HeaderComponentProps } from 'react-native-plain-calendar';
import { useTranslation } from 'react-i18next';
import parse from 'date-fns/parse';

import { BaseText } from '../../common/BaseText';
import { IconTouchable } from '../../common/IconTouchable';

const HeaderContainer = styled(View)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 24,
  mb: '$4',
});

const HeaderText = styled(BaseText)({
  variant: 'text.medium',
  color: '$heading800',
  fontWeight: 'semi',
});

export function CalendarHeader(props: HeaderComponentProps) {
  const { t } = useTranslation();
  const currentMonthDate = parse(
    props.currentMonth,
    'MMMM yyyy',
    new Date(),
  );

  const monthsText = `${t(
    `common.calendar.months.${currentMonthDate.getMonth()}`,
  )} ${currentMonthDate.getFullYear()}`;

  return (
    <HeaderContainer>
      <IconTouchable
        onPress={props.onPrevMonth}
        name="small-arrow-left-light"
        size={20}
      />
      <HeaderText>{monthsText}</HeaderText>
      <IconTouchable
        onPress={props.onNextMonth}
        name="small-arrow-right-light"
        size={20}
      />
    </HeaderContainer>
  );
}
